import ApiService from './ApiService';

class ShareTransferService {
  async shareInwardTransfer(payload = {}) {
    try {
      const response = await ApiService.call(
        '/secured/create_inward_share_transfer',
        'POST',
        payload,
      );
      let data = response;

      console.log(response);

      return {
        orderId: data.shareTransferId,
        success: true,
        message: 'Inward Share Transfer successfully!',
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async shareOutwardTransfer(payload = {}) {
    try {
      const response = await ApiService.call(
        '/secured/create_outward_share_transfer',
        'POST',
        payload,
      );
      let data = response;

      return {
        orderId: data.shareTransferId,
        success: true,
        message: 'Outward Share Transfer successfully!',
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new ShareTransferService();
